import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import StyledSegmentationFilters from 'automation-ui-enrollment/components/common/StyledSegmentationFilters';
import useEventEnrollmentStrategy from 'automation-ui-enrollment/hooks/useEventEnrollmentStrategy';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ON_START_KEYS = ['EDITED_FILTERS'];
const ON_DONE_KEYS = ['CONFIRMED_CHANGES', 'DISCARDED_CHANGES', 'CANCELED_CHANGES'];
const UI_MESSAGES = {
  // basically replaces 'filter' with 'trigger'
  addFilterButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.addTrigger"
  }),
  addFilterGroupButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.addTriggerGroup"
  }),
  editorAddFilterHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.addTrigger"
  }),
  editFiltersButtonLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.editTriggers"
  }),
  editorEditFilterHeaderLabel: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.editTrigger"
  }),
  filterSelectionBreadcrumbsStep1: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.triggerBreadcrumb"
  }),
  newFilterPlaceholderMessage: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.triggerAddPlaceholder"
  }),
  restrictedFiltersMessage: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.restrictedProperties"
  }),
  viewerEmptyFilters: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.noTriggers"
  }),
  conditionDeletePopoverHeader: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.deletePopoverHeader"
  }),
  conditionDeletePopoverDescription: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-enrollment.redesign.review.deletePopoverDescription"
  })
};
const EventSegmentationFilters = ({
  bannerComponents,
  objectTypeId,
  headerNode,
  subheaderNode,
  isEditButtonDisabled,
  editButtonDisabledTooltipMessage,
  showDoneButton = true,
  hideEditCancelDiscardButton,
  readOnly,
  value,
  openInEditMode,
  isEmbedded = false,
  strategyOptions = {},
  uiMessagesOverrides = {},
  useCustomEditorContainer = true,
  onChange = () => {},
  onAreFiltersIncompleteChange = () => {},
  onStartEditingFilters = () => {},
  onDoneEditingFilters = () => {},
  onFiltersEditorPanelOpenChange = () => {},
  WrapperComponent
}) => {
  const handleChange = (filterBranch, {
    hasIncompleteFilters,
    hasFilterValidationErrors
  }) => {
    if (!filterBranch) {
      onAreFiltersIncompleteChange(true);
    } else {
      onChange(filterBranch);
      onAreFiltersIncompleteChange(Boolean(hasIncompleteFilters || hasFilterValidationErrors));
    }
  };
  const {
    strategy: eventEnrollmentStrategy,
    /* TEMP (hopefully): need to keep SegmentationFilters from loading until all event property data has loaded.
     otherwise, the editor will mark valid/loading properties as invalid and not re-render when the properties load */
    initialized: eventEnrollmentStrategyInitialized
  } = useEventEnrollmentStrategy({
    objectTypeId,
    value,
    strategyOptions
  });
  const handleEditModeChange = editMode => {
    if (ON_START_KEYS.includes(editMode)) {
      onStartEditingFilters();
    } else if (ON_DONE_KEYS.includes(editMode)) {
      onDoneEditingFilters();
    }
  };
  const editButtonsState = {
    disabled: isEditButtonDisabled,
    tooltipTitle: editButtonDisabledTooltipMessage
  };
  const uiMessages = Object.assign({}, UI_MESSAGES, {
    filtersHeaderLabel: readOnly ? null : /*#__PURE__*/_jsx(_Fragment, {}),
    // function must be called in the component
    filterCategorySearchInputPlaceholder: I18n.text('automation-ui-enrollment.redesign.review.triggerSearchPlaceholder')
  }, uiMessagesOverrides);
  let content;
  if (!eventEnrollmentStrategyInitialized) {
    content = /*#__PURE__*/_jsx(UIFlex, {
      justify: "center",
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {})
    });
  } else if (readOnly && !value) {
    content = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.review.noTriggers"
    });
  } else {
    content = /*#__PURE__*/_jsx(StyledSegmentationFilters, {
      baseFilterFamily: objectTypeId,
      bannerComponents: bannerComponents
      // TODO - investigate supporting embed UI to fit panel width restrictions: https://issues.hubspotcentral.com/browse/AUTOPG-2179
      // Use unstyled editor container - context: https://hubspot.slack.com/archives/C01U0C5PRD2/p1700241865298149?thread_ts=1700233426.240869&cid=C01U0C5PRD2
      ,
      isEmbedded: isEmbedded,
      isReadOnly: readOnly,
      onChange: handleChange,
      onEditModeChange: handleEditModeChange,
      onFiltersEditorPanelOpenChange: onFiltersEditorPanelOpenChange,
      editButtonsState: editButtonsState,
      showDoneButton: showDoneButton,
      hideEditCancelDiscardButton: hideEditCancelDiscardButton,
      value: value,
      uiMessages: uiMessages,
      strategy: eventEnrollmentStrategy,
      openInEditMode: openInEditMode,
      skipEmptyFiltersState: openInEditMode,
      useCustomEditorContainer: useCustomEditorContainer
      // changes list membership operator copy: "is member of" => "is added to", "is not member of" => "is removed from"
      ,
      translationPrefix: "automationTriggers",
      WrapperComponent: WrapperComponent
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [headerNode, subheaderNode, content]
  });
};
export default EventSegmentationFilters;